export interface ImageUpload {
  basketId: string;
  itemId: string;
  quantityIndex: number;
  image: File;
}
